<date-input (valueOut)="setElement($event, 2)" [isFilter]="true"
[initialPlaceHolder]="'Desde'" [value]="elementSelected" [isIncomplete]="isIncomplete"></date-input>

<span class="text-is-incomplete invalid-text" style="position:absolute;" *ngIf="isIncomplete">Se deben rellenar ambas fechas.</span>